var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 551,
    height: 725,
    viewBox: "0 0 551 725",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_914_22872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.797 93.3403V103.751",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.797 114.98V131.822",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.47 6.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.797 137.437V147.847",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.226 269.491H427.792",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.539 269.491H399.658",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.47 6.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.031 269.491H383.597",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.996 269.491H149.562",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.308 269.491H121.428",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.47 6.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.801 269.491H105.367",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.106 327.835C443.792 307.105 440.06 235.796 440.06 235.796H451.054V227.282C477.107 227.282 495.106 211.145 495.106 211.145C495.106 211.145 513.106 227.282 539.159 227.282V235.796H550.152C550.152 235.796 546.421 307.105 495.106 327.835Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.115 318.417C461.493 302.701 451.748 261.117 449.064 243.161H459.109V234.196C475.581 232.342 488.337 225.207 495.115 220.562C501.893 225.207 514.65 232.342 531.123 234.196V243.161H541.148C538.432 261.126 528.622 302.743 495.115 318.417Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.005 285.417H477.209C475.912 285.417 474.858 284.367 474.858 283.071V261.796C474.858 260.5 475.91 259.45 477.209 259.45H513.005C514.302 259.45 515.356 260.5 515.356 261.796V283.071C515.354 284.367 514.302 285.417 513.005 285.417Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.84 237.528C487.485 237.116 480.555 243.781 480.555 252.029V253.54C480.555 254.102 481.012 254.559 481.576 254.559H485.255C485.819 254.559 486.276 254.102 486.276 253.54V252.34C486.276 247.652 489.813 243.552 494.501 243.238C499.643 242.892 503.938 246.97 503.938 252.029V253.54C503.938 254.102 504.396 254.559 504.959 254.559H508.639C509.202 254.559 509.659 254.102 509.659 253.54V252.451C509.658 244.641 503.657 237.913 495.84 237.528Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.909 269.517C498.909 267.421 497.207 265.722 495.106 265.722C493.006 265.722 491.303 267.421 491.303 269.517C491.303 271.018 492.185 272.303 493.453 272.919L492.068 279.02H498.144L496.76 272.919C498.028 272.303 498.909 271.018 498.909 269.517Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.392 81.1949H209.507C206.318 81.1949 203.734 78.6149 203.734 75.4346V6.8812C203.734 3.69913 206.319 1.12085 209.507 1.12085H332.392C335.582 1.12085 338.166 3.70086 338.166 6.8812V75.4346C338.167 78.6166 335.582 81.1949 332.392 81.1949Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.437 69.9987H254.957C256.062 69.9987 256.957 69.1052 256.957 68.0034V14.3107C256.957 13.209 256.062 12.3154 254.957 12.3154H216.437C215.332 12.3154 214.437 13.209 214.437 14.3107V68.0034C214.437 69.1052 215.332 69.9987 216.437 69.9987Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.697 69.9988H216.355C215.296 69.9988 214.437 69.1417 214.437 68.0851V54.7651C214.437 54.7651 225.296 54.2897 227.121 51.9873C228.945 49.6832 226.928 46.083 226.928 46.083C226.268 45.2606 226.103 39.4829 226.103 39.4829C226.103 39.4829 226.103 39.4829 225.455 39.318C224.804 39.1532 223.961 34.3645 223.961 32.5548C223.961 30.7452 225.455 30.0876 225.455 30.0876C225.455 30.0876 223.813 18.3882 235.699 18.3882C247.584 18.3882 245.943 30.0876 245.943 30.0876C245.943 30.0876 247.437 30.7452 247.437 32.5548C247.437 34.3645 246.591 39.1549 245.943 39.318C245.294 39.4829 245.294 39.4829 245.294 39.4829C245.294 39.4829 245.129 45.2588 244.47 46.083C244.47 46.083 242.453 49.6849 244.277 51.9873C246.101 54.2897 256.961 54.7651 256.961 54.7651V68.0851C256.961 69.1417 256.102 69.9988 255.043 69.9988H235.697Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.685 70.2764H298.276C297.165 70.2764 296.264 69.3776 296.264 68.2689C296.264 67.1602 297.165 66.2615 298.276 66.2615H324.685C325.796 66.2615 326.697 67.1602 326.697 68.2689C326.697 69.3776 325.796 70.2764 324.685 70.2764Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.685 16.0545H269.931C268.82 16.0545 267.919 15.1557 267.919 14.047C267.919 12.9383 268.82 12.0396 269.931 12.0396H324.685C325.796 12.0396 326.697 12.9383 326.697 14.047C326.697 15.1557 325.796 16.0545 324.685 16.0545Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.342 29.6086H269.931C268.82 29.6086 267.919 28.7099 267.919 27.6012C267.919 26.4925 268.82 25.5938 269.931 25.5938H301.342C302.453 25.5938 303.354 26.4925 303.354 27.6012C303.354 28.7099 302.453 29.6086 301.342 29.6086Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.338 43.1646H269.93C268.818 43.1646 267.918 42.2658 267.918 41.1571C267.918 40.0484 268.818 39.1497 269.93 39.1497H291.338C292.449 39.1497 293.35 40.0484 293.35 41.1571C293.35 42.2658 292.449 43.1646 291.338 43.1646Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.342 56.7205H269.931C268.82 56.7205 267.919 55.8217 267.919 54.713C267.919 53.6043 268.82 52.7056 269.931 52.7056H301.342C302.453 52.7056 303.354 53.6043 303.354 54.713C303.354 55.8217 302.453 56.7205 301.342 56.7205Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3861 214.335V291.43L56.5936 312.176H1.3772V214.335H77.3861Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3861 291.43L56.5936 312.176V291.43H77.3861Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8899 226.811H65.7769",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.988 235.427H65.7769",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.988 244.043H65.7769",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.988 252.659H65.7769",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.988 261.277H65.7769",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.988 269.894H65.7769",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.988 278.51H65.7769",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.988 287.126H58.8751",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0066 226.805H89.8856V303.9L69.0932 324.646H13.8767V315.53",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8856 303.9L69.0931 324.646V303.9H89.8856Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.246 378.257H179.655C175.584 378.257 172.283 374.964 172.283 370.902V168.077C172.283 164.016 175.584 160.722 179.655 160.722H362.245C366.315 160.722 369.616 164.016 369.616 168.077V370.904C369.616 374.964 366.315 378.257 362.246 378.257Z",
    fill: "#40B0D5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.641 233.24H176.26",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.641 257.408H176.26",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.641 281.573H176.26",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.641 305.741H176.26",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.641 329.908H176.26",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.641 354.076H176.26",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.641 209.073H176.26",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.641 184.906H176.26",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.388 374.379V164.602",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.669 374.379V164.602",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.95 374.379V164.602",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.231 374.379V164.602",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.512 374.379V164.602",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.793 374.379V164.602",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.107 374.379V164.602",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M264.101 335.761C266.507 323.733 269.281 313.514 272.747 303.619C273.498 301.506 274.326 299.373 275.23 297.106C277.386 291.611 281.796 280.411 280.141 277.068C279.756 276.318 279.005 275.799 278.292 275.799C278.137 275.799 278.042 275.818 277.849 275.973C272.938 279.969 269.782 291.054 267.49 299.143L266.72 301.87C263.638 312.513 261.618 323.772 260.289 335.049",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.303 336.241C273.615 324.963 276.233 315.301 279.525 305.982C280.219 303.964 281.047 301.851 281.932 299.623C285.359 290.901 289.634 280.085 286.554 273.898C284.956 270.709 281.721 268.653 278.294 268.653C276.446 268.653 274.771 269.248 273.307 270.44C266.664 275.858 263.294 287.691 260.599 297.182L259.828 299.89C256.747 310.495 254.688 321.658 253.339 332.801",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.755 335.57C280.718 326.348 283.106 317.357 286.283 308.347C290.018 297.704 298.433 281.681 292.964 270.71C288.496 261.738 276.771 258.395 268.78 264.908C259.633 272.343 256.015 287.252 252.933 297.914C249.988 308.095 247.946 318.683 246.541 329.249",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.571 333.418C288.439 325.177 290.538 317.819 293.04 310.71C293.656 308.942 294.445 306.964 295.273 304.851C299.74 293.516 305.286 279.396 299.375 267.523C295.389 259.531 287.11 254.363 278.29 254.363C273.131 254.363 268.278 256.093 264.254 259.358C254.107 267.619 250.062 281.855 246.809 293.285L246.058 295.936C243.381 305.158 241.437 314.706 240.03 324.273",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.929 329.287C296.391 323.562 297.991 318.24 299.799 313.073C300.396 311.402 301.128 309.499 301.917 307.502C306.654 295.475 313.123 279.049 305.788 264.351C300.608 253.939 289.807 247.214 278.292 247.214C271.456 247.214 265.045 249.501 259.731 253.823C247.831 263.506 243.441 278.933 239.917 291.343L239.166 293.976C236.932 301.698 235.181 309.633 233.833 317.586",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.556 322.314C305.206 310.849 314.389 297.241 315.3 281.336C316.135 266.763 311.322 257.429 307.924 252.741C306.24 250.417 305.945 247.421 306.917 244.723C308.454 240.463 309.76 233.308 306.693 224.161",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.777 202.74C293.878 210.293 301.766 222.188 302.338 237.484C302.543 242.991 298.054 244.895 292.435 243.184C280.666 239.601 252.634 230.454 235.546 278.395C232.087 288.097 230.077 298.606 228.326 308.902",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.708 203.528C260.616 203.566 269.964 203.528 279.435 208.603C290.906 214.752 298.139 229.229 294.435 232.923C290.341 237.007 282.723 227.128 259.442 236.655C248.23 241.244 240.293 250.556 234.885 261.147C232.421 265.972 230.431 271.028 228.729 276.165C226.554 282.736 224.82 289.537 223.396 296.377",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.519 212.364C249.313 211.058 253.646 210.751 257.131 210.674C277.677 210.218 285.391 221.144 283.127 223.925C281.229 226.257 277.011 224.943 271.211 225.653C254.483 227.697 241.265 237.193 232.353 251.231C227.872 258.289 224.575 266.012 221.933 273.92C221.452 275.36 221.008 276.802 220.567 278.242",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.822 224.161C244.067 216.964 252.713 216.011 259.108 216.131C261.718 216.18 268.144 216.978 269.013 219.435C270.156 222.665 259.705 218.279 244.543 228.365C225.119 241.286 222.763 253.533 222.763 253.533",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.803 313.628C311.803 313.628 322.331 290.929 321.258 273.381C320.568 262.082 314.98 254.994 314.095 249.961C313.21 244.928 315.66 243.623 315.001 239.087",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.565 206.753V174.691H217.701",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.701 364.29H185.565V332.228",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.336 206.753V174.691H324.2",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.2 364.29H356.336V332.228",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.5 726C524.11 713.09 475.651 644.851 468.424 633.55C468.408 633.534 468.394 633.52 468.394 633.504C459.168 619.079 452.511 608.561 452.511 608.561C448.972 591.522 443.957 584.832 438.926 570.839C433.91 556.846 438.045 544.373 440.121 527.043C442.182 509.696 438.926 493.58 437.165 482.632C435.388 471.682 437.464 461.334 437.165 458.904C436.866 456.475 426.82 443.696 422.982 434.269C421.266 430.04 418.788 426.118 415.861 422.812C412.279 418.737 408.038 415.57 403.798 413.893C401.618 413.032 399.633 412.539 397.797 412.279C393.109 411.588 389.289 412.371 385.482 412.371C380.168 412.371 368.955 402.945 361.566 401.437C360.193 401.159 358.819 400.96 357.416 400.837H357.356C351.251 400.253 344.847 400.914 337.651 401.421C330.575 401.897 322.2 395.039 315.511 392.855C315.481 392.839 315.436 392.825 315.391 392.808C313.734 392.285 312.181 392.04 310.777 392.285C303.686 393.5 290.4 394.714 290.4 394.714C290.4 394.714 289.221 385.287 288.623 372.508C288.519 370.294 288.369 368.156 288.175 366.065V366.019C287.488 358.13 286.384 351.072 286.204 344.627C286.145 342.937 286.159 341.276 286.264 339.66C286.846 330.557 286.577 323.421 286.293 309.505C286.277 309.028 286.277 308.536 286.264 308.029C286.175 303.676 286.218 299.524 286.01 295.757C286.01 295.741 285.994 295.741 285.994 295.741C285.502 286.638 283.546 279.917 274.754 278.518C267.066 277.303 261.75 281.255 258.512 294.342C255.257 307.429 252.899 306.506 252.019 325.667C251.123 344.828 246.988 357.007 247.584 366.74C248.167 376.474 246.106 395.327 246.106 395.327C242.568 393.496 239.314 395.019 238.702 396.541C238.09 398.064 235.478 412.965 233.402 423.621C231.565 433.079 223.206 441.83 220.114 448.35C220.085 448.396 220.069 448.457 220.04 448.504C219.697 449.258 219.412 449.996 219.233 450.687C217.456 457.376 218.353 471.677 218.353 489.932C218.353 508.17 213.919 527.037 218.353 539.202C219.233 541.616 220.577 543.861 222.264 546.014C229.056 554.671 241.536 562.13 252.897 576.001C267.064 593.348 277.111 606.126 286.561 611.909C293.324 616.03 296.294 619.382 297.534 623.826C297.549 623.856 297.549 623.872 297.549 623.872C298.041 625.626 298.25 627.562 298.325 629.762C298.445 633.636 300.49 636.604 303.938 641.527C307.432 646.508 312.358 653.491 318.15 665.438C321.936 673.237 344.922 709.578 351 726H532.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M286.265 339.665C286.161 341.279 286.145 342.942 286.206 344.633C274.92 342.433 253.125 348.17 252.796 355.027C252.408 363.392 251.422 383.168 255.557 387.766C259.693 392.364 268.545 395.332 268.545 395.332C267.874 395.379 267.231 395.47 266.605 395.594C266.589 395.594 266.575 395.61 266.575 395.61C266.5 395.624 266.426 395.64 266.367 395.656C263.41 396.303 260.962 397.809 258.976 399.932L258.96 399.948C250.332 409.067 249.958 429.289 252.796 439.022C264.619 479.451 245.466 511.468 238.704 507.591C231.941 503.731 231.344 468.947 233.403 460.797C235.478 452.647 235.21 446.173 235.21 446.173C232.195 445.143 225.865 446.65 220.043 448.511C220.073 448.464 220.088 448.403 220.118 448.357C223.208 441.836 231.569 433.086 233.405 423.628C235.48 412.972 238.093 398.071 238.705 396.548C239.317 395.026 242.571 393.503 246.11 395.334C246.11 395.334 248.17 376.481 247.588 366.747C246.991 357.014 251.127 344.835 252.022 325.674C252.902 306.513 255.262 307.435 258.515 294.349C261.755 281.262 267.069 277.31 274.757 278.525C283.551 279.924 285.505 286.644 285.997 295.748C285.011 294.809 283.937 293.886 282.787 293.071C279.89 291.012 276.517 289.58 273.009 290.089C268.933 290.673 265.367 294.872 263.111 299.346V299.362C259.856 305.791 259.319 312.772 263.903 310.404C269.083 307.727 279.772 308.619 286.295 309.512C286.578 323.428 286.848 330.562 286.265 339.665Z",
    fill: "#40B0D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M298.328 629.767C298.253 627.567 298.045 625.631 297.553 623.877C297.553 623.877 297.553 623.861 297.537 623.831C296.297 619.387 293.327 616.034 286.564 611.914C277.115 606.132 267.067 593.353 252.9 576.006C241.54 562.135 229.059 554.678 222.267 546.019C230.821 550.802 242.435 548.341 246.108 555.892C251.422 566.796 276.428 583.311 276.428 583.311C300.836 608.254 298.328 629.767 298.328 629.767Z",
    fill: "#40B0D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M315.391 392.812C312.525 392.212 304.731 411.987 303.985 419.016C302.029 437.208 311.09 493.321 299.432 492.06C294.61 491.537 288.968 465.333 288.623 453.123C287.578 416.018 289.027 400.609 289.027 400.609C289.027 400.609 286.444 380.064 288.176 366.071C288.371 368.163 288.521 370.3 288.625 372.514C289.221 385.292 290.402 394.72 290.402 394.72C290.402 394.72 303.689 393.505 310.779 392.291C312.181 392.044 313.733 392.289 315.391 392.812Z",
    fill: "#40B0D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M357.355 400.839C351.07 401.423 344.754 407.758 339.619 408.897C333.319 410.282 321.795 395.703 315.509 392.859C322.197 395.042 330.572 401.901 337.649 401.424C344.845 400.916 351.249 400.255 357.355 400.839Z",
    fill: "#40B0D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M397.797 412.281C395.528 414.803 391.379 422.215 390.377 425.567C385.317 442.406 390.094 506.132 381.943 495.705C371.315 482.141 382.406 435.116 374.673 417.155C372.209 411.403 363.476 402.223 361.565 401.438C368.955 402.945 380.166 412.372 385.48 412.372C389.289 412.372 393.109 411.588 397.797 412.281Z",
    fill: "#40B0D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M468.394 633.504C460.124 623.892 451.45 614.742 445.778 611.298C431.969 602.932 428.013 594.259 426.818 579.804C425.639 565.334 429.192 565.671 433.327 551.386C437.462 537.084 429.774 519.43 430.371 523.245C430.953 527.059 424.458 553.508 419.668 554.816C414.861 556.107 413.247 538.301 412.651 523.768C412.055 509.236 419.742 441.575 417.593 428.35C417.251 426.213 416.652 424.383 415.861 422.813C418.788 426.12 421.266 430.041 422.982 434.27C426.818 443.698 436.866 456.476 437.165 458.905C437.464 461.336 435.388 471.684 437.165 482.634C438.926 493.582 442.18 509.698 440.121 527.044C438.046 544.375 433.911 556.847 438.926 570.84C443.957 584.834 448.974 591.524 452.511 608.562C452.511 608.562 459.169 619.081 468.394 633.504Z",
    fill: "#40B0D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M343.749 436.845C346.89 440.244 348.867 484.762 350.639 495.712C352.411 506.662 346.899 532.872 343.749 524.938C340.6 517.005 330.954 422.995 343.749 436.845Z",
    fill: "#40B0D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.759 725.274C345.551 711.391 321.451 672.241 318.152 665.443C312.359 653.493 307.433 646.513 303.939 641.53C300.491 636.609 298.446 633.641 298.326 629.765C298.251 627.565 298.043 625.629 297.551 623.875C297.551 623.875 297.551 623.859 297.535 623.828C296.295 619.384 293.325 616.031 286.562 611.911C277.113 606.129 267.065 593.35 252.898 576.004C241.538 562.133 229.057 554.676 222.265 546.017C220.578 543.864 219.234 541.619 218.354 539.205C213.92 527.04 218.354 508.173 218.354 489.934C218.354 471.682 217.459 457.38 219.234 450.69C219.413 449.999 219.697 449.261 220.041 448.506C220.071 448.46 220.086 448.399 220.116 448.352C223.206 441.832 231.567 433.082 233.403 423.624C235.478 412.968 238.091 398.067 238.703 396.544C239.315 395.022 242.569 393.499 246.108 395.33C246.108 395.33 248.168 376.477 247.586 366.743C246.989 357.009 251.124 344.831 252.02 325.67C252.9 306.509 255.26 307.431 258.513 294.344C261.753 281.258 267.067 277.306 274.755 278.521C283.549 279.92 285.503 286.64 285.995 295.743C285.995 295.743 286.011 295.743 286.011 295.76C286.22 299.527 286.174 303.679 286.265 308.031C286.281 308.538 286.281 309.031 286.294 309.507C286.578 323.424 286.847 330.56 286.265 339.663C286.161 341.277 286.145 342.939 286.206 344.63C286.385 351.073 287.489 358.133 288.176 366.021V366.068C288.371 368.16 288.52 370.297 288.625 372.511C289.221 385.29 290.402 394.717 290.402 394.717C290.402 394.717 303.689 393.503 310.779 392.288C312.182 392.043 313.735 392.288 315.392 392.811C315.437 392.827 315.482 392.842 315.512 392.858C322.2 395.041 330.575 401.9 337.652 401.423C344.848 400.917 351.252 400.256 357.358 400.84H357.417C358.82 400.963 360.194 401.162 361.568 401.44C368.958 402.946 380.169 412.373 385.483 412.373C389.29 412.373 393.112 411.589 397.799 412.282C399.635 412.544 401.621 413.036 403.8 413.896C408.039 415.573 412.279 418.74 415.863 422.815C418.789 426.121 421.267 430.042 422.983 434.271C426.82 443.699 436.867 456.478 437.166 458.906C437.465 461.337 435.389 471.685 437.166 482.635C438.928 493.583 442.181 509.699 440.122 527.046C438.048 544.376 433.913 556.848 438.928 570.842C443.959 584.835 448.975 591.525 452.512 608.563C452.512 608.563 459.171 619.082 468.396 633.507C468.396 633.523 468.411 633.537 468.425 633.553C474.833 643.573 524.29 713.706 531.791 725.274",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.106 395.334C246.106 408.718 244.926 425.346 242.957 432.241C240.989 439.135 242.322 462.253 238.704 471.987",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.799 405.879C252.799 405.879 261.856 395.334 268.549 395.334C275.242 395.334 281.935 399.796 289.023 400.606C296.111 401.417 303.486 396.02 310.285 394.73",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.917 357.075C257.917 357.075 270.123 352.476 276.423 357.075",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.17 351.128C267.17 351.128 270.91 350.085 276.423 352.837",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.906 318.683C263.906 318.683 270.123 317.06 276.423 318.683",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.121 448.352C220.121 448.352 227.995 444.409 231.146 444.002",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.808 460.799C240.808 460.799 236.125 468.336 235.21 471.987",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.906 285.831C263.906 285.831 262.021 301.319 263.906 302.7C265.791 304.081 280.36 305.374 281.541 302.7C282.721 300.025 282.944 288.671 282.944 288.671C282.944 288.671 274.227 273.259 263.906 285.831Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.408 423.623C233.408 423.623 245.482 417.352 245.776 408.374C246.07 399.397 242.51 399.486 238.01 399.438",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.706 444.002C422.099 458.198 418.162 499.565 417.769 505.648C417.374 511.731 417.769 527.283 417.769 527.283",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.481 411.531C348.474 431.025 335.481 423.623 343.749 516.6",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.514 608.561C452.514 608.561 440.997 599.334 439.029 594.062",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.774 604.194C295.222 610.099 297.417 623.032 297.537 623.831C297.553 623.861 297.553 623.878 297.553 623.878",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_914_22872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 551,
    height: 742,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step-2.ef1ac723469cd56f7203f9425a3e1315.svg";
export { ForwardRef as ReactComponent };